import React from 'react';

import {ExamConfirmationBooking} from 'presentation/modules/booking/exam/ui/pages/ExamConfirmationBooking';

export const MakeExamConfirmationBooking = () => {
	return <ExamConfirmationBooking />;
};
